// extracted by mini-css-extract-plugin
export var originalPrice = "_vn-0";